import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddIntrestForm from "./AddIntrest";
import EditIntrestForm from "./EditIntrest";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const Interst = () => {
  const [intrests, setIntrests] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentIntrest, setCurrentIntrest] = useState(null);
  const [loading, setLoading] = useState(true);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchIntrests = async () => {
      try {
        const response = await axios.get(`${Api}/api/intrest-rates`);
        setIntrests(response.data.intrestRates);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };
    fetchIntrests();
  }, []);

  const handleDeleteIntrest = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Interest?")) return;
    try {
      await axios.delete(`${Api}/api/intrest-rates/${id}`);
      setIntrests(intrests.filter((i) => i._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting interest", err);
    }
  };

  const handleAddIntrest = (newIntrest) => setIntrests([...intrests, newIntrest]);

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Interest</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>VFC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Interest</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-cash-multiple" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Interest List</span>
          {permissions.includes("AddIntrest") && (
            <button onClick={() => setShowAddPopup(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Interest Name</th>
                <th style={thStyle}>Interest Rate</th>
                {permissions.includes("EditIntrest") && permissions.includes("DeleteIntrest") && (
                  <th style={thStyle}>Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {intrests.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No interest records found.</td>
                </tr>
              ) : (
                intrests.map((item, index) => (
                  <tr key={item._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{item.intrestName}</td>
                    <td style={tdStyle}>{item.intrestRate}</td>
                    {permissions.includes("EditIntrest") && permissions.includes("DeleteIntrest") && (
                      <td style={tdStyle}>
                        <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                          onClick={() => { setCurrentIntrest(item); setShowEditPopup(true); }} />
                        <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                          onClick={() => handleDeleteIntrest(item._id)} />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showAddPopup && <AddIntrestForm onClose={() => setShowAddPopup(false)} onAddIntrest={handleAddIntrest} />}
      {showEditPopup && currentIntrest && <EditIntrestForm intrest={currentIntrest} onClose={() => { setShowEditPopup(false); setCurrentIntrest(null); }} />}
    </div>
  );
};

export default Interst;
